/* Cakesomarvellous "Lights Off, Candle On" r1: homepage motion (5 Oct 2026). Loaded on the homepage only.
   1. Candlelight follows you (hero .pool[data-fx-light]): the warm light eases toward the mouse, softly held near the cake;
      on touch it follows a sideways drag or a hold / tap, otherwise the CSS drift moves it (no script per frame).
   2. Cocoa dust ([data-fx-dust]: the hero tiramisu, the tiramisu lead): a few fine specks fall where the mouse passes.
   3. Hover to cut (.lead__plate[data-fx-cut]): a knife line follows the mouse or a sideways swipe and shows the second
      photo beside it; at rest the lead's own photo.
   The logo's flame glow is CSS only (csm-candle-r1.css, .brand__glow).
   Nothing runs without html.js-anim (set in the layout: never for reduce motion or ?static), and nothing starts before
   the load event + an idle moment. One shared requestAnimationFrame loop that stops when nothing moves; only transform
   and opacity are written, and the canvas is drawn only while specks are alive and on screen. Listeners are passive
   (except one capture click that cancels a lead's link after a swipe). Vertical page scrolling is never blocked:
   the pool and the plates use touch-action: pan-y, so the browser keeps vertical drags. */
(function () {
  "use strict";
  var html = document.documentElement;
  if (!html.classList.contains("js-anim") || !window.requestAnimationFrame || !window.matchMedia) return;
  var reduce = matchMedia("(prefers-reduced-motion: reduce)");
  var fine = matchMedia("(hover: hover) and (pointer: fine)");
  var P = { passive: true };
  var soft = function (v, m) { return m > 0 ? m * Math.tanh(v / m) : 0; };
  var ease = function (dt, tau) { return 1 - Math.exp(-dt / tau); };
  var rnd = function (a, b) { return a + Math.random() * (b - a); };

  /* Rectangles are read on pointer events only, cached until the page scrolls or resizes */
  var gen = 0;
  var bump = function () { gen++; };
  window.addEventListener("scroll", bump, P);
  window.addEventListener("resize", bump, P);
  var rect = function (el, st) { if (st.g !== gen || !st.r) { st.r = el.getBoundingClientRect(); st.g = gen; } return st.r; };

  /* One frame loop for every effect: each job returns true while it still moves */
  var jobs = [], raf = 0, last = 0;
  var tick = function (t) {
    raf = 0;
    var dt = last ? Math.min(50, t - last) : 16, more = false;
    last = t;
    for (var i = 0; i < jobs.length; i++) if (jobs[i](dt)) more = true;
    if (more) raf = requestAnimationFrame(tick); else last = 0;
  };
  var wake = function () { if (!raf && !document.hidden) raf = requestAnimationFrame(tick); };
  document.addEventListener("visibilitychange", function () { last = 0; if (!document.hidden) wake(); });

  /* ---------- 1. Candlelight follows you ---------- */
  var light = function (pool) {
    var beam = pool.querySelector(".pool__beam"), dim = pool.querySelector(".pool__dim");
    if (!beam) return;
    var hero = pool.closest(".hero") || pool;
    var cake = pool.querySelector(".pool__cake"), foot = pool.querySelector(".pool__foot");
    var st = {}, g, x = 0, y = 0, tx = 0, ty = 0, a = 0, ta = 0, wx = "", wa = "";
    var idleA = function () { return fine.matches ? 0 : 0.7; };
    var measure = function () {
      var w = cake ? cake.offsetWidth : pool.offsetWidth * 0.5;
      // the light leans toward the pointer but stays on the cake, and never drops onto the caption under it
      var room = foot && foot.offsetTop > beam.offsetTop ? foot.offsetTop - beam.offsetTop - w * 0.5 : w * 0.2;
      g = { ax: beam.offsetLeft, ay: beam.offsetTop, mx: w * 0.42, up: w * 0.34, down: Math.max(0, Math.min(w * 0.3, room)) };
      // the shade is larger than the pool by the light's reach, its hole on the resting light
      if (dim) {
        var m = Math.ceil(Math.max(g.mx, g.up, g.down)) + 2;
        dim.style.inset = -m + "px";
        dim.style.setProperty("--hx", g.ax + m + "px"); dim.style.setProperty("--hy", g.ay + m + "px");
      }
    };
    var aim = function (cx, cy) {
      var r = rect(pool, st);
      if (!g) measure();
      var dx = cx - r.left - g.ax, dy = cy - r.top - g.ay;
      tx = soft(dx, g.mx); ty = soft(dy, dy < 0 ? g.up : g.down);
    };
    var rest = function () { tx = 0; ty = 0; ta = idleA(); wake(); };
    jobs.push(function (dt) {
      var k = ease(dt, 210);
      x += (tx - x) * k; y += (ty - y) * k; a += (ta - a) * ease(dt, 380);
      var s = "translate3d(" + x.toFixed(1) + "px," + y.toFixed(1) + "px,0)", o = a.toFixed(3);
      if (s !== wx) { beam.style.transform = s; if (dim) dim.style.transform = s; wx = s; }
      if (o !== wa) {
        beam.style.opacity = o; wa = o;
        // the resting pool dims a little only while the light is being moved (not for the idle drift)
        var i0 = idleA();
        if (dim) dim.style.opacity = (Math.max(0, a - i0) / (1 - i0)).toFixed(3);
      }
      return Math.abs(tx - x) > 0.2 || Math.abs(ty - y) > 0.2 || Math.abs(ta - a) > 0.002;
    });
    window.addEventListener("resize", function () { g = null; requestAnimationFrame(function () { if (!g) measure(); }); }, P);

    // Mouse: anywhere over the hero (over the words the light leans their way, held on the cake)
    hero.addEventListener("pointermove", function (e) {
      if (e.pointerType !== "mouse" || reduce.matches) return;
      aim(e.clientX, e.clientY); ta = 1; wake();
    }, P);
    hero.addEventListener("pointerleave", function (e) { if (e.pointerType === "mouse") rest(); }, P);

    // Touch: a hold, a tap or a sideways drag on the picture moves the light; a vertical drag is the page scrolling
    var t0 = null, hold = 0, back = 0;
    var follow = function (e) { aim(e.clientX, e.clientY); ta = 1; wake(); };
    pool.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse" || reduce.matches) return;
      clearTimeout(back); clearTimeout(hold);
      t0 = { x: e.clientX, y: e.clientY, t: e.timeStamp, on: false };
      var ev = { clientX: e.clientX, clientY: e.clientY };
      hold = setTimeout(function () { if (t0) { t0.on = true; follow(ev); } }, 170);
    }, P);
    pool.addEventListener("pointermove", function (e) {
      if (!t0 || e.pointerType === "mouse") return;
      if (!t0.on) {
        var dx = Math.abs(e.clientX - t0.x), dy = Math.abs(e.clientY - t0.y);
        if (dx > 6 && dx > dy) t0.on = true; else return;
      }
      follow(e);
    }, P);
    var end = function (e) {
      if (!t0 || e.pointerType === "mouse") return;
      clearTimeout(hold);
      var tap = e.type === "pointerup" && e.timeStamp - t0.t < 260;
      if (tap) { t0.on = true; follow(e); }
      var was = t0.on; t0 = null;
      if (was) back = setTimeout(rest, tap ? 1400 : 900);
    };
    pool.addEventListener("pointerup", end, P);
    pool.addEventListener("pointercancel", end, P);
    fine.addEventListener && fine.addEventListener("change", rest);

    // the light joins once the candle has lit (the lighting sequence takes ~1.2s)
    measure();
    setTimeout(rest, html.classList.contains("is-lit") ? 300 : 1400);
    if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { pool.classList.toggle("fx-off", !es[0].isIntersecting); }).observe(pool);
  };

  /* ---------- 2. Cocoa dust ---------- */
  var COCOA = "rgb(66,40,27)", LIT = "rgb(255,228,190)", MAX = 60;
  var dust = function (host, opts) {
    var c, ctx, w = 0, h = 0, ps = [], seen = true, dirty = false, st = {}, lastT = 0, lx = -99, ly = -99;
    var setup = function () {
      if (!c) {
        c = document.createElement("canvas");
        c.className = "fx-dust"; c.setAttribute("aria-hidden", "true");
        host.appendChild(c); ctx = c.getContext("2d");
      }
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      w = host.clientWidth; h = host.clientHeight;
      c.width = Math.round(w * dpr); c.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    var emit = function (x, y, n, vx, puff) {
      for (var i = 0; i < n && ps.length < MAX; i++) {
        ps.push({
          x: x + rnd(-9, 9), y: y + rnd(-5, 4),
          vx: puff ? rnd(-0.045, 0.045) : vx * 0.035 + rnd(-0.01, 0.01),
          vy: puff ? rnd(-0.03, 0.012) : rnd(-0.004, 0.02),
          r: rnd(0.6, 1.35) * (opts.size || 1), life: rnd(1300, 2400), age: 0, ph: rnd(0, 6.3),
          lit: Math.random() < opts.lit
        });
      }
      dirty = true; wake();
    };
    jobs.push(function (dt) {
      if (!c || !dirty) return false;
      ctx.clearRect(0, 0, w, h);
      if (!seen) ps.length = 0;
      for (var j = ps.length - 1; j >= 0; j--) {
        var q = ps[j];
        q.age += dt;
        if (q.age >= q.life) { ps.splice(j, 1); continue; }
        q.vy += 0.000028 * dt; q.vx *= 0.986;
        q.x += (q.vx + Math.sin(q.ph + q.age * 0.0035) * 0.006) * dt;
        q.y += q.vy * dt;
      }
      for (var pass = 0; pass < 2; pass++) {
        ctx.fillStyle = pass ? LIT : COCOA;
        for (var i = 0; i < ps.length; i++) {
          var p = ps[i];
          if (p.lit !== (pass === 1)) continue;
          var t = p.age / p.life, al = t < 0.12 ? t / 0.12 : 1 - (t - 0.12) / 0.88;
          if (p.lit) {
            // a mote catching the candlelight: a soft halo round a bright core
            ctx.globalAlpha = al * 0.16; ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 2.8, 0, 6.2832); ctx.fill();
          }
          ctx.globalAlpha = al * (p.lit ? 0.95 : 0.85);
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.2832); ctx.fill();
        }
      }
      ctx.globalAlpha = 1;
      if (!ps.length) dirty = false;
      return dirty;
    });
    var local = function (e) { var r = rect(host, st); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
    host.addEventListener("pointermove", function (e) {
      if (e.pointerType !== "mouse" || reduce.matches || !seen) return;
      var p = local(e), d = Math.abs(p.x - lx) + Math.abs(p.y - ly), now = e.timeStamp;
      if (now - lastT < 28 || d < 4) return;
      var vx = (p.x - lx) / Math.max(16, now - lastT);
      lastT = now; lx = p.x; ly = p.y;
      if (!opts.over(e)) return;
      if (!c || host.clientWidth !== w) setup();
      emit(p.x, p.y, d > 22 ? 2 : 1, Math.max(-1, Math.min(1, vx)), false);
    }, P);
    var down = null;
    host.addEventListener("pointerdown", function (e) { if (e.pointerType !== "mouse") down = { x: e.clientX, y: e.clientY, t: e.timeStamp }; }, P);
    host.addEventListener("pointerup", function (e) {
      if (!down || e.pointerType === "mouse" || reduce.matches) return;
      var tap = e.timeStamp - down.t < 300 && Math.abs(e.clientX - down.x) + Math.abs(e.clientY - down.y) < 10;
      down = null;
      if (!tap || !opts.over(e)) return;
      if (!c || host.clientWidth !== w) setup();
      var p = local(e); emit(p.x, p.y, 14, 0, true);
    }, P);
    host.addEventListener("pointercancel", function () { down = null; }, P);
    window.addEventListener("resize", function () { if (c) { ps.length = 0; setup(); } }, P);
    if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; if (!seen && c) { dirty = true; wake(); } }).observe(host);
  };

  /* ---------- 3. Hover to cut ---------- */
  var cut = function (plate) {
    var base = plate.querySelector("img");
    if (!base) return;
    var wrap, win, img, knife, st = {}, W = 1, x = 0, tx = 0, v = 0, tv = 0, side = 0, wk = "", built = false, out = 0, swiped = false;
    var build = function () {
      if (built) return; built = true;
      wrap = document.createElement("span"); wrap.className = "cut"; wrap.setAttribute("aria-hidden", "true");
      win = document.createElement("span"); win.className = "cut__win";
      img = document.createElement("img"); img.className = "cut__img"; img.decoding = "async";
      img.sizes = base.getAttribute("sizes") || "100vw"; img.srcset = plate.getAttribute("data-fx-cut");
      img.alt = plate.getAttribute("data-cut-alt") || "";
      knife = document.createElement("span"); knife.className = "cut__knife";
      win.appendChild(img); wrap.appendChild(win); wrap.appendChild(knife); plate.appendChild(wrap);
    };
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { build(); io.disconnect(); } }, { rootMargin: "400px 0px" });
      io.observe(plate);
    } else build();
    var apply = function () {
      var k = Math.round(x * 2) / 2, s = side + ":" + k + ":" + v.toFixed(3);
      if (s === wk) return; wk = s;
      if (side === 0) { win.style.transform = "translate3d(" + (k - W) + "px,0,0)"; img.style.transform = "translate3d(" + (W - k) + "px,0,0)"; }
      else { win.style.transform = "translate3d(" + k + "px,0,0)"; img.style.transform = "translate3d(" + -k + "px,0,0)"; }
      knife.style.transform = "translate3d(" + k + "px,0,0)";
      wrap.style.opacity = v.toFixed(3);
    };
    jobs.push(function (dt) {
      if (!built) return false;
      x += (tx - x) * ease(dt, 95); v += (tv - v) * ease(dt, tv ? 110 : 170);
      apply();
      return Math.abs(tx - x) > 0.3 || Math.abs(tv - v) > 0.003;
    });
    var start = function (cx, fromRight) {
      build(); clearTimeout(out);
      var r = rect(plate, st); W = r.width || 1;
      side = fromRight ? 1 : 0;
      wrap.className = "cut cut--" + (side ? "r" : "l");
      if (v < 0.02) x = side ? W : 0;
      tx = Math.max(0, Math.min(W, cx - r.left)); tv = 1; wake();
    };
    var move = function (cx) { var r = rect(plate, st); tx = Math.max(0, Math.min(W, cx - r.left)); wake(); };
    var stop = function (delay) { clearTimeout(out); out = setTimeout(function () { tv = 0; wake(); }, delay); };
    plate.addEventListener("pointerenter", function (e) {
      if (e.pointerType !== "mouse" || reduce.matches) return;
      var r = rect(plate, st); start(e.clientX, e.clientX - r.left > r.width / 2);
    }, P);
    plate.addEventListener("pointermove", function (e) { if (e.pointerType === "mouse" && tv) move(e.clientX); }, P);
    plate.addEventListener("pointerleave", function (e) { if (e.pointerType === "mouse") stop(0); }, P);
    // Touch: only a sideways swipe; a vertical one is the page scrolling (touch-action: pan-y)
    var t0 = null;
    plate.addEventListener("pointerdown", function (e) { if (e.pointerType !== "mouse" && !reduce.matches) t0 = { x: e.clientX, y: e.clientY, on: false }; }, P);
    plate.addEventListener("pointermove", function (e) {
      if (!t0 || e.pointerType === "mouse") return;
      var dx = e.clientX - t0.x, dy = e.clientY - t0.y;
      if (!t0.on) { if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy) * 1.2) { t0.on = true; start(e.clientX, dx < 0); } return; }
      move(e.clientX);
    }, P);
    var end = function (e) { if (!t0 || e.pointerType === "mouse") return; if (t0.on) { swiped = true; stop(900); } t0 = null; };
    plate.addEventListener("pointerup", end, P);
    plate.addEventListener("pointercancel", end, P);
    // a swipe is not a click on the lead's link
    plate.addEventListener("click", function (e) { if (swiped) { e.preventDefault(); swiped = false; } }, true);
    window.addEventListener("resize", function () { if (built) { tv = 0; v = 0; wk = ""; wrap.style.opacity = "0"; } }, P);
  };

  /* ---------- Start: after load, when the browser is idle ---------- */
  var init = function (root) {
    Array.prototype.forEach.call(root.querySelectorAll(".pool[data-fx-light], .pool[data-fx-dust], .lead__plate[data-fx-cut], .lead__plate[data-fx-dust]"), function (el) {
      if (el.__fx) return; el.__fx = 1;
      if (el.classList.contains("pool")) {
        if (el.hasAttribute("data-fx-light")) light(el);
        if (el.hasAttribute("data-fx-dust")) {
          var cake = el.querySelector(".pool__cake"), cst = {};
          if (cake) dust(el, { lit: 0.7, over: function (e) {
            // over the tub: an ellipse in the middle of the (turned) picture
            var r = rect(cake, cst), dx = (e.clientX - r.left - r.width / 2) / (r.width * 0.4), dy = (e.clientY - r.top - r.height * 0.47) / (r.height * 0.4);
            return dx * dx + dy * dy <= 1;
          } });
        }
      } else {
        if (el.hasAttribute("data-fx-cut")) cut(el);
        if (el.hasAttribute("data-fx-dust")) dust(el, { lit: 0.12, size: 1.2, over: function () { return true; } });
      }
    });
  };
  var go = function () {
    var run = function () { init(document); };
    if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 1200 }); else setTimeout(run, 200);
  };
  if (document.readyState === "complete") go(); else window.addEventListener("load", go, { once: true });
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
